<template>
  <div class="participation-analysis-wrap">
    <v-row class="am-cards">
      <v-col cols="12" sm="12" md="4" lg="4" class="">
        <div class="am-card">
          <h3 class="am-card-title">Engagement score
            <div class="info-icon pt-5" style="display: initial;" name="Engagement23">
              <i class="las la-info-circle ls-4"></i>
            </div>
            <tippy to="Engagement23"
              interactive="true"
              theme="light amara"
              class="am-tool"
              :allowHTML="true"
              arrow
              placement="right"
            >
              <h3 class="am-card-title pr-1"><b>Engagement score</b></h3>
              <p>
                This is the average engagement score of the company calculated based on the latest conversations with each employee.
              </p>
              <v-btn class="am-tool-btn" small color="red">
                +&nbsp;Read more&nbsp;(Coming soon...)
              </v-btn>
            </tippy>
          </h3>
          <div class="card-body participation" v-if="dashboardData.engagement_score">
            <span class="engagement">{{dashboardData.engagement_score.toFixed(1)}}</span>
            <span class="score-sub">/5</span>
          </div>
          <div class="card-body participation am-no-data" v-else>
            {{noDataText}}
          </div>
          <div
            class="am-card-action"
            :style="{
              background: `linear-gradient(0deg,
                ${getEngagementColor(dashboardData.engagement_score)}24 0%,
                #ffffff 100%)`
            }"
          >
            <div class="action-sub">{{getEngagementType(dashboardData.engagement_score)}}</div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="4"  class="">
        <div class="am-card">
          <h3 class="am-card-title">Employees' vibe
            <span class="info-icon pt-2" style="" name="vibe23">
              <i class="las la-info-circle ls-4"></i>
            </span>
            <tippy to="vibe23"
              interactive="true"
              theme="light amara"
              class="am-tool"
              :allowHTML="true"
              arrow
              placement="right"
            >
              <h3 class="am-card-title pr-1"><b>Employees' vibe</b></h3>
              <p>
                This is the average of employees’ overall feelings about the tenure that they have spent in the organization.
              </p>
              <v-btn class="am-tool-btn" small color="red">
                +&nbsp;Read more&nbsp;(Coming soon...)
              </v-btn>
            </tippy>
          </h3>
          <div class="card-body vibe" v-if="dashboardData.overall_mood">
            <img
              :src="getImgUrl(Math.round(dashboardData.overall_mood))"
              :alt="dashboardData.overall_mood_str"
            >
          </div>
          <div class="card-body vibe am-no-data" v-else>
            {{noDataText}}
          </div>
          <div class="am-card-action" v-if="dashboardData.overall_mood_str">
            <div class="action-sub">
              <v-row no-gutters>
                <v-col cols="12">
                  Employees are feeling
                </v-col>
                <v-col cols="12">
                  <div>{{(dashboardData.overall_mood_str).toUpperCase()}}</div>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="4" class="">
        <div class="am-card">
          <h3 class="am-card-title">Disengaged employees
            <span class="info-icon pt-5 " style="" name="Disengaged23">
              <i class="las la-info-circle ls-4"></i>
            </span>
            <tippy to="Disengaged23"
              interactive="true"
              theme="light amara"
              class="am-tool"
              :allowHTML="true"
              arrow
              placement="right"
            >
              <h3 class="am-card-title pr-1"><b>Disengaged employees</b></h3>
              <p>
                Employees’ whose engagement score is less than or equal to 3 are disengaged.
              </p>
              <v-btn class="am-tool-btn" small color="red">
                +&nbsp;Read more&nbsp;(Coming soon...)
              </v-btn>
            </tippy>
          </h3>
          <div class="card-body disengaged"
            v-if="dashboardData.disengaged_employees_stats
              && dashboardData.disengaged_employees_stats.disengaged_employees"
          >
            <div class="disengaged-score"
              v-if="dashboardData.disengaged_employees_stats"
            >{{dashboardData.disengaged_employees_stats.disengaged_employees}}</div>
            <div class="disengaged-score" v-else>0</div>
            <v-row class="disengaged-stats">
              <v-col cols="6">
                <v-row no-gutters>
                  <v-col cols="12" class="stat-text">Open</v-col>
                  <v-col cols="12" class="stat-score"
                    v-if="dashboardData.disengaged_employees_stats"
                  >{{dashboardData.disengaged_employees_stats.disengaged_cases_open}}</v-col>
                  <v-col cols="12" class="stat-score" v-else>0</v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="resolved">
                <v-row no-gutters>
                  <v-col cols="12" class="stat-text">Resolved</v-col>
                  <v-col cols="12" class="stat-score"
                    v-if="dashboardData.disengaged_employees_stats"
                  >{{dashboardData.disengaged_employees_stats.disengaged_cases_resolved}}</v-col>
                  <v-col cols="12" class="stat-score" v-else>0</v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
          <div class="card-body disengaged am-no-data" v-else>
            {{noDisengagedText}}
          </div>
          <div class="am-card-action"
            v-if="dashboardData.disengaged_employees_stats
                && dashboardData.disengaged_employees_stats.disengaged_employees"
          >
            <div class="action-sub">
              <div>
                <span v-if="dashboardData.disengaged_employees_stats"
                >{{dashboardData.disengaged_employees_stats.disengaged_employees}}&nbsp;</span>
                <span v-else>0&nbsp;</span>
                <span>out of&nbsp;</span>
                <span v-if="dashboardData.disengaged_employees_stats"
                >{{dashboardData.disengaged_employees_stats.employees_reached}}&nbsp;</span>
                <span v-else>0&nbsp;</span>
                <span>employees are disengaged</span>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import StagesMixin from '../stages-mixin';

export default {
  name: 'ParticipationAnalysis',

  mixins: [StagesMixin],

  // data () {
  //   return {
  //     empReached: 0
  //   };
  // },

  watch: {
    dashboardData: {
      deep: true,
      handler () {
        // this.empReached = this.dashboardData.company_employee_reach_stats.employee_reach_percent;
      }
    }
  },

  methods: {
    getImgUrl (pet) {
      if (!isNaN(pet)) {
        const images = require.context('@/assets/', false, /\.png$/);
        return images(`./${pet}.png`);
      }
    },
    getEngagementColor (score) {
      let color = '#fff';
      if (score) {
        if (score <= 3) {
          color = '#f44336';
        } else if (score <= 4) {
          color = '#ff9800';
        } else if (score <= 5) {
          color = '#4caf50';
        }
      }
      return color;
    },
    getEngagementType (score) {
      let engagement = '';
      if (score) {
        if (score <= 3) {
          engagement = 'Disengaged';
        } else if (score <= 4) {
          engagement = 'Passively engaged';
        } else if (score <= 5) {
          engagement = 'Highly engaged';
        }
      }
      return engagement;
    }
  }
};
</script>

<style lang="scss" scoped>
.participation-analysis-wrap {
  .am-cards {
    .am-card {
      width:100%;
      position:relative;
      background-color: var(--bg);
      border-radius: 6px;
      box-shadow: 0 4px 20px 1px rgba(0,0,0,.06), 0 1px 4px rgba(0,0,0,.08) !important;
      height: 16rem;
      transition: 0.5s;
      -webkit-transition: 0.5s;
      text-align: center;
      color: var(--color-text);
      &:hover {
        transform: scale(1.05);
        // box-shadow: 10px 10px 15px rgba(0,0,0,0.3);
      }
      .am-card-title {
        padding: 16px;
        font-size: var(--content-size);
        font-weight: var(--text-weight);
        color: var(--color-text);
        text-align: center;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        height: 3.5rem;
      }
      .card-body {
        position: relative;
        padding: 0 16px;
        height: 9rem;
        &.participation {
          margin: 0 auto;
          .engagement {
            color: var(--color-text);
            font-size: 6rem;
          }
          .score-sub {
            color: var(--color-text);
            font-size: 3rem;
          }
        }
        &.vibe {
          padding-top: 0.8rem;
          img {
            width: 35%;
            margin: 0 auto;
          }
        }
        &.disengaged {
          .disengaged-score {
            font-size: 3rem;
            color: var(--color-text);
          }
          .disengaged-stats {
            .stat-text {
              font-size: var(--content-sub-size);
              color: var(--color-text);
            }
            .stat-score {
              color: var(--color-text);
              font-size: var(--content-sub-size);
              font-weight: var(--heading-weight);
            }
            .resolved {
              border-left: 1px solid rgba(0, 0, 0, 0.1);
            }
          }
        }
        &.reached {
          #chartReached {
            height: 9rem;
            font-size: 12px;
          }
        }
      }
      .am-card-action {
        height: 3.5rem;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        padding: 0 16px;
        display: flex;
        width: 100%;
        place-content: center;
        .action-sub {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: var(--content-sub-size);
        }
      }
    }
  }
}
</style>
